var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopyIcon = function SvgCopyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.302 14.819V8.285a3.792 3.792 0 0 1 3.793-3.79H40.27a3.792 3.792 0 0 1 3.794 3.79v21.156a3.792 3.792 0 0 1-3.794 3.79h-6.505",
    stroke: "#6112A3",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.323 15.092H7.828a3.132 3.132 0 0 0-3.133 3.13v22.476a3.132 3.132 0 0 0 3.133 3.13h22.495a3.132 3.132 0 0 0 3.134-3.13V18.222a3.132 3.132 0 0 0-3.134-3.13Z",
    stroke: "#A112FF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    fill: "none"
  })));
};

export { SvgCopyIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCA0NyA0NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMwMTYgMTQuODE4NVY4LjI4NTI0QzE1LjMwMTYgNi4xOTE4NyAxNyA0LjQ5NDg3IDE5LjA5NTIgNC40OTQ4N0g0MC4yNjkxQzQyLjM2NDMgNC40OTQ4NyA0NC4wNjI3IDYuMTkxODcgNDQuMDYyNyA4LjI4NTI0VjI5LjQ0MTFDNDQuMDYyNyAzMS41MzQ1IDQyLjM2NDMgMzMuMjMxNSA0MC4yNjkxIDMzLjIzMTVIMzMuNzY0IiBzdHJva2U9IiM2MTEyQTMiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIGZpbGw9Im5vbmUiIC8+CjxwYXRoIGQ9Ik0zMC4zMjM1IDE1LjA5Mkg3LjgyODQ4QzYuMDk4MTUgMTUuMDkyIDQuNjk1NDMgMTYuNDkzNiA0LjY5NTQzIDE4LjIyMjRWNDAuNjk4M0M0LjY5NTQzIDQyLjQyNzEgNi4wOTgxNSA0My44Mjg2IDcuODI4NDggNDMuODI4NkgzMC4zMjM1QzMyLjA1MzkgNDMuODI4NiAzMy40NTY2IDQyLjQyNzEgMzMuNDU2NiA0MC42OTgzVjE4LjIyMjRDMzMuNDU2NiAxNi40OTM2IDMyLjA1MzkgMTUuMDkyIDMwLjMyMzUgMTUuMDkyWiIgc3Ryb2tlPSIjQTExMkZGIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBmaWxsPSJub25lIiAvPgo8L3N2Zz4K";